import React from 'react';

import { Form, Field } from 'react-final-form';
import { CheckboxField, SelectField, TextField, LocationsField } from '/components/forms/fields';

import { ValidationService } from '/services';

const namePrefixOptions = [
    {"label":"Meneer","value":"Meneer"},
    {"label":"Mevrouw","value":"Mevrouw"},
    {"label":"Juffrouw","value":"Juffrouw"},
    {"label":"Meneer en mevrouw","value":"Meneer en mevrouw"},
];

const EstateSearchForm = () => {
    const initialValues = {
        locations: [],
    };

    const validate = (values) => {
        const rules = {
            purpose: 'required',
            firstName: 'required',
            lastName: 'required',
            email: 'required|email',
            mobile: 'required',
            privacy: 'required',
            subCategories: 'required',
            minPrice: 'required',
            maxPrice: 'required',
            locations: 'required',
            namePrefix: 'required',
        };

        const names = {
            purpose: 'transactie',
            firstName: 'voornaam',
            lastName: 'achternaam',
            email: 'e-mailadres',
            mobile: 'telefoonnummer',
            subCategories: 'type',
            minPrice: 'minimum prijs',
            maxPrice: 'maximum prijs',
            locations: 'gemeentes',
            minBedrooms: 'minimum aantal slaapkamers',
            namePrefix: 'aanspreking',
        };

        return ValidationService.validate(values, rules, names);
    };

    const submit = async (values) => {
        const body = new FormData();
        body.append(window.csrfTokenName, window.csrfTokenValue);
        body.append('firstName', values.firstName);
        body.append('lastName', values.lastName);
        body.append('email', values.email);
        body.append('mobile', values.mobile);
        body.append('purpose', values.purpose && values.purpose.value);
        body.append('minPrice', values.minPrice);
        body.append('maxPrice', values.maxPrice);
        body.append('locations', values.locations.map(xxx => xxx.postalCode).join(','));
        body.append('bedrooms', values.minBedrooms ? values.minBedrooms : 0);
        body.append('subCategories', values.subCategories.value);
        body.append('namePrefix', values.namePrefix.value);

        try {
            const response = await fetch('/index.php?p=actions/vitsync/estate-form/search', {
                method: 'post',
                body,
            });

            const bodyFromResponse = await response.json();

            if (bodyFromResponse.success) {
                window.location = window.successRedirect;
            } else {
                window.location = window.failureRedirect;
            }
        } catch {
            window.location = window.failureRedirect;
        }
    };

    const render = ({ handleSubmit }) => (
        <div className="block-corners estate-search-form-wrapper block--estate-search-form">
            <div className="block-corner block-corner--top-right"></div>
            <div className="block-corner block-corner--bottom-left"></div>
            <div className="container is-horizontal is-vertical">
                <form className="estate-search-form" onSubmit={handleSubmit}>
                    <div className="estate-search-form__row">
                        <div className="estate-search-form__col estate-search-form__col--left">
                            <h2 className="estate-search-form__title headline-3 font-supplementary--medium">
                                Op zoek naar
                            </h2>
                            <Field
                                name="purpose"
                                component={SelectField}
                                label="Transactie"
                                placeholder="Transactie *"
                                options={window.purposeOptions}
                                required
                            />
                            <Field
                                name="subCategories"
                                component={SelectField}
                                label="Type"
                                placeholder="Type *"
                                options={window.categoryOptions}
                                required
                            />
                            <Field
                                name="locations"
                                component={LocationsField}
                                label="Postcode of gemeente"
                                placeholder="Postcode of gemeente *"
                                required
                            />
                            <Field
                                name="minBedrooms"
                                component={TextField}
                                label="Aantal slaapkamers"
                                placeholder="Aantal slaapkamers"
                                type="number"
                                min="0"
                                required
                            />
                            <Field
                                name="minPrice"
                                component={TextField}
                                label="Minimum prijs"
                                placeholder="Minimum prijs *"
                                min="0"
                                type="number"
                                required
                            />
                            <Field
                                name="maxPrice"
                                component={TextField}
                                label="Maximum prijs"
                                placeholder="Maximum prijs *"
                                type="number"
                                min="1"
                                required
                            />
                        </div>
                        <div className="estate-search-form__col estate-search-form__col--right">
                            <h2 className="estate-search-form__title headline-3 font-supplementary--medium">
                                Uw gegevens
                            </h2>

                            <Field
                                name="namePrefix"
                                component={SelectField}
                                label="Aanspreking"
                                placeholder="Aanspreking *"
                                options={namePrefixOptions}
                                required
                            />
                            <Field
                                name="firstName"
                                component={TextField}
                                label="Voornaam"
                                placeholder="Voornaam *"
                                type="text"
                                required
                            />
                            <Field
                                name="lastName"
                                component={TextField}
                                label="Naam"
                                placeholder="Naam *"
                                type="text"
                                required
                            />
                            <Field
                                name="email"
                                component={TextField}
                                label="E-mailadres"
                                placeholder="E-mailadres *"
                                type="email"
                                required
                            />
                            <Field
                                name="mobile"
                                component={TextField}
                                label="Telefoonnummer"
                                placeholder="Telefoonnummer *"
                                type="tel"
                                required
                            />
                        </div>
                    </div>

                    <div className="estimate-form__actions">
                        <div className="estimate-form__actions-item estimate-form__actions-item__left">
                            <Field
                                name="privacy"
                                component={CheckboxField}
                                label={window.privacyMessage}
                                type="checkbox"
                                required
                            />
                        </div>
                        <div className="estimate-form__actions-item estimate-form__actions-item__right">
                            <button className="button" type="submit">
                                Houd me op de hoogte
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );

    return (
        <Form
            initialValues={initialValues}
            validate={validate}
            onSubmit={submit}
            render={render}
        />
    );
};

export { EstateSearchForm };
